import React, { Component } from 'react'
import { Grid, Cell } from 'react-mdl'
import Education from './education';
import Experience from './experience';
import Skills from './skills';
export default class Resume extends Component {
  render() {
    return (
      <div>
        <Grid>

          <Cell col={4}>
            <div style={{ textAlign: 'center' }}>
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS4uAfoapDbR_ycxF4hltMedCYIqj9bcOZB-ZuD8Sf89rdrGtTv" alt="avatar" style={{ height: '200px' }} />
            </div>
            <h2 style={{ paddingTop: '1em' }}>Shamaz Shaikh</h2>
            <h4 style={{ color: 'grey' }}>Programmer</h4>
            <hr style={{ borderTop: '3px solid #833fb2', width: '50%' }} />
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis, beatae, inventore unde voluptas maiores recusandae libero consequatur laudantium necessitatibus enim ut omnis ea accusantium quasi! Cumque maiores porro assumenda temporibus?</p>
            <hr style={{ borderTop: '3px solid #833fb2', width: '50%' }} />
            <h5>Address</h5>
            <p>800 D-Block Faisalabad</p>
            <h5>Phone</h5>
            <p>03087175332</p>
            <h5>Email</h5>
            <p>Shamazsaeed332@gmail.com</p>
            <h5>Website</h5>
            <p>www.techwares.com</p>
            <hr style={{ borderTop: '3px solid #833fb2', width: '50%' }} />
          </Cell>

          <Cell className="resume-right-col" col={8}>
            <h2>Education</h2>
            <Education startyear={2012}
              endyear={2015}
              schoolName='DPS Sahiwal'
              schoolDescription='Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis, beatae?'
            />
             <Education startyear={2015}
              endyear={2022}
              schoolName='NTU Faisalabad'
              schoolDescription='Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis, beatae'
            />
            <hr style={{borderTop:'3px solid #e22947'}}/>
            <h1>Experience</h1>
          <Experience
          startyear={2013}
          endyear={2016}
          jobName='First Job'
          jobDescription='Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis, beatae'
/>
<Experience
          startyear={2013}
          endyear={2016}
          jobName='First Job'
          jobDescription='Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis, beatae'
/>
<hr style={{borderTop:'3px solid #e22947'}}/>
<h1>Skills</h1>
<Skills
skills="JavaScript"
progress={100}
/>
<Skills
skills="HTML | CSS"
progress={80}
/>

<Skills
skills="Node JS"
progress={50}
/>
<Skills
skills="React"
progress={25}
/>



          </Cell>
        </Grid>
      </div>
    )
  }
}
